import { __read } from 'tslib';
import * as React from 'react';
import { useTextCopy } from '@invitae/cms-blocks';
import { useCountryLocationPrefix, useKeyPress } from '@invitae/nucleobase-engine-contentful';
import { ResultsListItem } from '../ResultsListItem/ResultsListItem.esm.js';
import styles from './ResultsList.module.esm.js';

var ResultsList = function (_a) {
    var title = _a.title, searchResult = _a.searchResult, searchValue = _a.searchValue, handleAnalyticsEvent = _a.handleAnalyticsEvent;
    var searchResultFound = searchResult && searchResult.length > 0;
    var _b = __read(React.useState(null), 2), selectedResultIndex = _b[0], setSelectedResultIndex = _b[1];
    var componentRef = React.useRef(null);
    var addCountryCodePrefix = useCountryLocationPrefix().addCountryCodePrefix;
    var getText = useTextCopy().getText;
    var upPress = useKeyPress('ArrowUp', componentRef).pressed;
    var downPress = useKeyPress('ArrowDown', componentRef).pressed;
    React.useEffect(function () {
        if (searchResultFound && downPress) {
            setSelectedResultIndex(function (prevIndex) {
                if (prevIndex === null) {
                    return 0;
                }
                return prevIndex < searchResult.length + 1 ? prevIndex + 1 : prevIndex;
            });
        }
    }, [downPress]);
    React.useEffect(function () {
        if (searchResultFound && upPress) {
            setSelectedResultIndex(function (prevIndex) {
                if (prevIndex === null) {
                    return null;
                }
                return prevIndex > 0 ? prevIndex - 1 : prevIndex;
            });
        }
    }, [upPress]);
    var handleSuggestionClick = function (analyticsEvent) {
        handleAnalyticsEvent(analyticsEvent);
    };
    if (searchResultFound) {
        return (React.createElement("div", { className: styles.navigationSearchSuggestionWrapper, "data-cy": "nav_search-result", ref: componentRef },
            searchResult.length && title && React.createElement("h3", { className: styles.navigationSearchSuggestionTitle }, title),
            React.createElement("ul", { className: styles.navigationSearchResultWrapper, "data-testid": "navigation-search-list" },
                searchResult.map(function (_a, index) {
                    var result = _a.result, url = _a.url;
                    var prefixedUrl = addCountryCodePrefix(url);
                    return (React.createElement(ResultsListItem, { active: index === selectedResultIndex, key: result, onClick: function () { return handleSuggestionClick(prefixedUrl); }, resultIndex: index, setSelectedResultIndex: setSelectedResultIndex, title: result, url: prefixedUrl }));
                }),
                searchValue && (React.createElement(ResultsListItem, { active: searchResult.length + 1 === selectedResultIndex, key: "See all", onClick: function () { return handleSuggestionClick('See all'); }, resultIndex: searchResult.length + 1, setSelectedResultIndex: setSelectedResultIndex, title: "<b>".concat(getText('seeAll'), "</b>"), url: "/search/?q=".concat(searchValue) })))));
    }
    //if no results provided
    if (!!searchResult && searchValue) {
        return (React.createElement("div", { className: styles.noResultText, "data-cy": "nav_search-result", ref: componentRef },
            React.createElement("p", { "data-cy": "nav-search-resultEmpty", "data-testid": "nav-search-resultEmpty" },
                getText('noResults'),
                " ",
                React.createElement("b", null,
                    "'",
                    searchValue,
                    "'")),
            React.createElement("ul", null,
                React.createElement(ResultsListItem, { active: selectedResultIndex === 0, key: "See all", onClick: function () { return handleSuggestionClick(searchValue); }, resultIndex: 0, setSelectedResultIndex: setSelectedResultIndex, title: "<b>".concat(getText('seeAll'), "</b>"), url: "/search/?q=".concat(searchValue) }))));
    }
    return null;
};

export { ResultsList };
//# sourceMappingURL=ResultsList.esm.js.map
